module.exports = __webpack_public_path__ + "img/logo-camp-azul-icone.974cda71.png";